"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapping = void 0;
var Wrapping;
(function (Wrapping) {
    Wrapping["NoWrap"] = "u-nowrap";
})(Wrapping = exports.Wrapping || (exports.Wrapping = {}));
//# sourceMappingURL=Wrapping.js.map